import React, { FunctionComponent } from 'react';

import {
  calculatePolicyExpiryDate,
  toShortMonthFormat,
} from 'scenes/common/helpers/datetime';

import { PolicySummary } from 'scenes/common/components/PolicySummary';
import AccountCreated from './AccountCreated';
import { InsuranceList } from './InsuranceList';
import { Confirmation } from './Confirmation';
import { PaymentConfirmationProps } from './types';

const PaymentConfirmationStep: FunctionComponent<PaymentConfirmationProps> = ({
  quoteNumber,
  receiptNumber,
  policyStartDate,
  paymentDate,
  contactEmail,
  paymentMethod,
  paymentFrequency,
  firstInstalment,
  monthlyInstalment,
  insuranceName,
}) => (
  <>
    <PolicySummary
      policyNumber={quoteNumber}
      policyStartDate={toShortMonthFormat(policyStartDate)}
      policyExpiryDate={toShortMonthFormat(
        calculatePolicyExpiryDate(policyStartDate)
      )}
    />

    <Confirmation
      receiptNumber={receiptNumber}
      contactEmail={contactEmail}
      paymentMethod={paymentMethod}
      paymentFrequency={paymentFrequency}
      paymentDate={paymentDate}
      firstInstalment={firstInstalment}
      monthlyInstalment={monthlyInstalment}
    />
    <AccountCreated />
    <InsuranceList insuranceName={insuranceName} />
  </>
);

export default PaymentConfirmationStep;
